export default __webpack_public_path__ + "static/media/0397.3684ed34.jpg";